<template>
  <div class="quick-order-wrap">
    <template>
      <WaitingQuickOrder
        v-if="orderInfo"
        ref="waiting"
        :quickMatchUuid="orderInfo.uuid"
        :onlyVoiceText="onlyVoiceText"
        :showCountdownPopup="showCountdownPopup"
        @finish="orderEnd"
        @error="handleError"
        @setIdentify="isSelf = $event"
      />
      <CreateQuickOrder
        v-else
        ref="create"
        :now-hour="nowHour"
        :onlyVoiceText="onlyVoiceText"
        @create="creatOrderInfo"
        @popupCountdown="showCountdownPopup"
        @error="handleError"
        @setIdentify="isSelf = $event"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateQuickOrder from './quick-order-create'
import WaitingQuickOrder from './quick-order-waiting'

export default {
  components: {
    CreateQuickOrder,
    WaitingQuickOrder
  },
  data() {
    return {
      inited: false,
      orderInfo: null,
      isSelf: true,
      nowHour: new Date().getHours(),
      lastErrTime: 0,
      onlyVoiceText: '搶單請錄製語音',
      showCountdownPopup: false, // 点击我要约单
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'userPermissions'])
  },
  async created() {
    this.$store.dispatch('app/getQuickOrderLegalTime')

    let quickMatch = this.userPermissions.quickMatch
    if (!Object.keys(this.userPermissions).length) {
      try {
        let data = await this.$store.dispatch('app/getWhiteListUser')
        quickMatch = data.quickMatch
      } catch(e) {
        console.log(e)
      }
    }

    if (quickMatch !== 'Open') {
      return this.$router.replace({
        name: 'homepage'
      })
    }
  },
  methods: {
    orderEnd() {
      location.reload()
    },
    // 極速約單下單錯誤處理
    handleError(err) {
      const nowTime = Date.now()
      if (nowTime - this.lastErrTime < 3000) return
      this.lastErrTime = nowTime
      if (!err) {
        this.$message.error('伺服器有點不聽話，工程師正在努力馴服中')
        this.cancelLoading()
        return
      }
      if (err.code == 701) {
        this.$confirm({
          content: err.msg,
          title: '餘額不足',
          confirmButtonText: '我要儲值',
          cancelButtonText: '取消',
        }).then(() => {
          this.$router.push({
            name: 'Saving',
            query: {
              redirect: encodeURIComponent(location.href)
            }
          })
        }).catch(() => {
          this.cancelLoading()
        })
      } else {
        this.$message.error(err.msg)
        this.cancelLoading()
      }
    },
    creatOrderInfo(info, isCreate) {
      this.orderInfo = info;
      this.showCountdownPopup = !!isCreate;
    },
    cancelLoading() {
      const comp = this.$refs['create'] || this.$refs['waiting']
      if (comp && comp.isLoading) {
        comp.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .quick-order-wrap {
    width: 100%!important;
    min-height: calc(100vh - 68px);
    overflow: hidden;
    background: $color-dark;
  }
</style>
